import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormDataFile,
    downloadBlob,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";

const initialState = {
    pagination: {
        data: [],
        per_page: 10,
        total: 0,
    },
    list: null,
    active: null,
};

export const GraduationOptionsRequestsDates = createSlice({
    name: "GraduationOptionsRequestsDates",
    initialState,
    reducers: {
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        clearPagination: (state) => {
            state.pagination = initialState.pagination;
        },

        setList: (state, action) => {
            state.list = action.payload;
        },
        clearList: (state) => {
            state.list = initialState.list;
        },

        setActive: (state, action) => {
            state.active = action.payload;
        },
        clearActive: (state) => {
            state.active = initialState.active;
        },
    },
});

export const {
    setPagination,
    clearPagination,
    setList,
    clearList,
    setActive,
    clearActive,
} = GraduationOptionsRequestsDates.actions;

export default GraduationOptionsRequestsDates.reducer;

//* Actions
export const startShowGraduationOptionsRequestsDates = ({
    page = 1,
    query = "",
    number_rows = 10,
    asList = 0,
    is_open = null,
    graduation_option_type = "",
    start_date = "",
    end_date = "",
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        if (asList) {
            params.set("asList", asList);
        } else {
            params.set("page", page);
            params.set("q", query);
            params.set("per_page", number_rows);
        }

        if (is_open !== null && is_open !== "") {
            params.set("is_open", is_open);
        }
        if (graduation_option_type) {
            params.set("graduation_option_type", graduation_option_type);
        }
        if (start_date) {
            params.set("start_date", start_date);
        }
        if (end_date) {
            params.set("end_date", end_date);
        }

        const resp = await Call(
            `operators/graduation/requests/dates/show`,
            "GET",
            params.toString()
        );

        if (resp.success) {
            if (asList) {
                dispatch(setList(resp.success));
            } else {
                dispatch(setPagination(resp.success));
            }
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startExportGraduationOptionsRequestsDates = ({
    is_open = null,
    graduation_option_type = "",
    start_date = "",
    end_date = "",
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();

        params.set("export", 1);
        if (is_open !== null && is_open !== "") {
            params.set("is_open", is_open);
        }
        if (graduation_option_type) {
            params.set("graduation_option_type", graduation_option_type);
        }
        if (start_date) {
            params.set("start_date", start_date);
        }
        if (end_date) {
            params.set("end_date", end_date);
        }

        const resp = await CallWithFormDataFile(
            `operators/graduation/requests/dates/show`,
            "GET",
            params.toString()
        );

        downloadBlob(
            resp,
            "Fechas de apertura de solicitudes de opción de titulación"
        );

        dispatch(stopUILoading());
    };
};

export const startCreateGraduationOptionRequestDate = (
    values,
    setErrors,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/graduation/requests/dates/create`,
            "POST",
            values
        );

        if (resp.success) {
            callback();

            Swal.fire({
                title: "Éxito",
                text: "Fecha de apertura para solicitudes registrada.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startEditGraduationOptionRequestDate = (
    graduation_option_request_date_id,
    values,
    setErrors = () => {},
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/graduation/requests/dates/edit/${graduation_option_request_date_id}`,
            "PUT",
            values
        );

        if (resp.success) {
            callback();

            Swal.fire({
                title: "Éxito",
                text: "Fecha de apertura para solicitudes actualizada.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startSyncGraduationOptionRequestDate = (
    graduation_option_request_date_id,
    callback = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `operators/graduation/requests/dates/sync/${graduation_option_request_date_id}`,
            "PUT"
        );

        if (resp.success) {
            callback();

            Swal.fire({
                title: "Éxito",
                text: "Formularios para solicitudes sincronizados.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};
